import { Preferences } from "../../profile/objects/preferences";
import { ORGANISATION_RUBRICS_MODULE } from "../constants/organisation.constants";
import { OrganisationRubricConfiguration } from "../objects/organisationRubricConfiguration";
import { OrganisationRubricsItemInterface } from "../objects/organisationRubricsItemInterface";

export const setOrganisationRubricPreference = (new_preferences: Preferences[], state_columns: OrganisationRubricsItemInterface[]): OrganisationRubricConfiguration => {
    const field_name: string[] = [];
    const columns: OrganisationRubricsItemInterface[] = [];
    const preferences: Preferences[] = [];
    new_preferences.map((preference: Preferences) => {
        if (preference.module === ORGANISATION_RUBRICS_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                columns.push({ id: Number(preference.id), field_name: preference.field_name, checked: preference.active });
                preferences.push(preference);
                field_name.push(preference.field_name);
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].field_name === column.field_name) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { columns, preferences };
};